const styles = {
    profileButton: {
        background: '#3876AA',
        borderRadius: '16px',
        width: '200px',
        height: '48px',
        textTransform: 'none',
        mt: 5,
        ml: 3,
    },
    profileField: {
        marginTop: '24px',
    },
    warning: {
        fontFamily: 'Silka_Regular',
        fontSize: '14px',
        lineHeight: '21px',
        color: '#5C697B',
        fontWeight: 400,
        ml: 3,
        mb: 5,
    },
    error_message: {
        marginTop: '24px',
        color: '#ED0000',
        fontFamily: 'Silka_Regular',
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '21px',
        ml: 3,
        mb: 1,
    },
    member_label: {
        fontFamily: 'Silka_Semi_Bold',
        marginTop: '38px',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: 'rgba(0, 0, 0, 0.6)',
    },
    deny_access: {
        width: '177px',
        height: '21px',
        fontFamily: 'Silka_Regular',
        fontWeight: 600,
        fontSize: '14px',
        color: '#ED0000',
        marginTop: '24px',
    },
    statusContainer: {
        mt: 2,
        mb: 3,
        display: 'flex',
    },
    statusText: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#001533',
        ml: 1,
    },
    inputLabel: {
        fontFamily: 'Silka_Semi_Bold',
        mt: 3,
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: 'rgba(0, 0, 0, 0.6)',
    },
    addAddressContainer: {
        mt: 3,
        padding: 0,
    },
    addAddressText: {
        fontFamily: 'Silka_Semi_Bold',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '21px',
        color: '#8697AB',
        mr: 1,
    },
    addressField2: {
        marginTop: '21px',
    },
};
export default styles;
